<template>
	<div>
		<navbar></navbar>
		<div class="admin">
			<div class="row" v-if="authorized === true">
				<div class="col-md-1 col-xs-12">
					<md-whiteframe class="navigation">
						<md-list>
							<md-list-item>
								<router-link to="/admin/home"><div class="item"><md-icon>dashboard</md-icon></br>{{$t("home_page")}}</div></router-link>
							</md-list-item>

							<md-list-item>
								<router-link to="/admin/patients"><div class="item"><md-icon>accessibility</md-icon></br>{{$t("patients")}}</div></router-link>
							</md-list-item>

							<md-list-item v-if="admin">
								<router-link to="/admin/doctors">
								<div class="item">
								<md-icon>local_hospital</md-icon></br>{{$t("admin.doctors")}}</div></router-link>
							</md-list-item>

							<md-list-item>
								<router-link to="/admin/profile"><div class="item"><md-icon>person</md-icon></br> {{$t("profile")}}</div></router-link>
							</md-list-item>

							<md-list-item>
								<router-link to="/admin/feed"><div class="item"><md-icon>public</md-icon></br>{{$t("news")}}</div></router-link>
							</md-list-item>

							<!--
							<md-list-item>
								<div class="item row center-md"><div class="col-md-12"><md-icon>access_time</md-icon></div> <span>Consultation</span></div>
							</md-list-item>

							<md-list-item>
								<div class="item row center-md"><div class="col-md-12"><md-icon>settings</md-icon></div> <span>Settings</span></div>
							</md-list-item>-->

							<md-list-item @click.native="openDialog()">
								<div class="item"><md-icon>warning</md-icon></br>{{$t("report_problem")}}</div>
							</md-list-item>
						</md-list>
					</md-whiteframe>
				</div>
				<div class="col-md col-xs-12">
					<router-view></router-view>
				</div>
			</div>
			<div v-else>
				{{$t("admin.needsignin")}}
			</div>
			<div class="admin-footer">
				Pulmoment.com - Build: {{getHash()}}
			</div>
		</div>
	</div>
</template>

<script>

	import Navbar from '../Navbar'
	import Api from '../../../generated'
	import _ from 'lodash'

	export default {
		components: {
			Navbar
		},
		data () {
			return {
				authorized: false,
				admin: false
			}
		},
		methods: {
			getHash(){
				return __COMMIT_HASH__;
			},
			openDialog(){
				this.$bus.$emit('showContact', 'support');
			},
			checkUser(){
				// TODO: only call this once, maybe on navbar or in a separate service
				this.$bus.$emit('showLoading', true);
				Api.ApiClient.instance.profile((error, data, response) => {
					if (error) {
						console.error(error);
						this.authorized = false;
					} else {
						console.log('logged in?');
						this.authorized = true;
						if(response.body.data.group === "admin" || _.includes(response.body.data.groups, "admin")){
							this.admin = true;
						}
					}
					console.log(response);
					this.$bus.$emit('showLoading', false);
				})
			}
		},
		mounted(){
			this.checkUser()
		}
	}
</script>

<style scoped>

	.admin{
		margin: 16px;
	}
	.admin-footer{
		text-align: center;
		color: #777;
	}
	.item{
		width: 100%;
		font-size: 10pt;
		overflow: hidden;
		text-align: center;
		margin: 0;
	}
	.router-link-active .md-icon{
		color: inherit;
	}
</style>



// WEBPACK FOOTER //
// AdminView.vue?39cb8e59